import "./layout.css";

const AuthWrapper = ({ children }: { children: any }) => {
  return <div className="auth_wrapper">{children}</div>;
};

export default AuthWrapper;
